/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {Provider} from 'react-redux'
import './index.scss'
import {configureMccStore, MccProvider} from '@enisco/mcc-react-lib'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import en from './lang/compiled/en.json'
import de from './lang/compiled/de.json'
import cs from './lang/compiled/cs.json'
import OpenApiPage from './open-api/OpenApiPage'
import UserInfoPage from './user-info/UserInfoPage'
import appsSlice from './portal/store/appsSlice'
import {createRoot} from 'react-dom/client'
import LicenseInfoApp from './license/LicenseInfoApp'
import {LicensePrintView} from './license/LicensePrintView'
import {ExternalApp} from './portal/ExternalApp'
import {HardlinkApp} from './portal/HardlinkApp'
import {FavoriteApp} from './portal/FavoriteApp'
import {HomeApp} from './portal/HomeApp'
import {Portal} from './portal/components/Portal'

const messages: Record<string, any> = {en, de, cs}

const store = configureMccStore({
  discoveryOverrides: {
    'mcc-portal-api': 'REACT_APP_OVERRIDE_API'
  },
  additionalReducers: {
    app: appsSlice
  }
})

const container = document.getElementById('root')
const root = createRoot(container!)
const location = window.location
root.render(
  <Provider store={store}>
    <MccProvider translations={messages}>
      <BrowserRouter>
        <Routes>
          <Route path='/mcc-portal-ui'>
            <Route path='apps'>
              <Route path='openapi' element={<OpenApiPage />} />
              <Route path='user-info' element={<UserInfoPage />} />
              <Route path='license-info' element={<LicenseInfoApp />} />
              <Route
                path='license-info/:application/print'
                element={<LicensePrintView />}
              />
            </Route>
            <Route
              path='favorites/:favorite'
              element={
                <Portal>
                  <FavoriteApp key={`favorite-${location.pathname}`}/>
                </Portal>
              }
            />
            <Route
              path='hardlinks/:hardlink'
              element={
                <Portal>
                  <HardlinkApp key={`hardlink-${location.pathname}`} />
                </Portal>
              }
            />
            <Route
              path='client/:module/:app'
              element={
                <Portal>
                  <ExternalApp key={`app-${location.pathname}`}/>
                </Portal>
              }
            />
            <Route path='' element={<HomeApp />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MccProvider>
  </Provider>
)
